<h3 *ngIf="data == null" mat-dialog-title>Cadastrar Característica da Renda Fixa</h3>
<h3 *ngIf="data != null" mat-dialog-title>Alterar Característica da Renda Fixa</h3>
<div mat-dialog-content>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Tipo</mat-label>
                <mat-select 
                    placeholder="Tipo"
                    [(value)]="model.tipo_id" 
                    [formControl]="tipo_id"
                    name="tipo_id"
                >
                    <mat-option value="">SELECIONE</mat-option>
                    <mat-option *ngFor="let tipo of listTipoProduto" [value]="tipo.id">{{tipo.nome}}</mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerProduto"></mat-spinner>
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field style="width: 100%" appearance="outline" fxFlex="100">
                <input 
                    matInput 
                    placeholder="Código" 
                    [formControl]="codigo" 
                    maxlength="255">
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field style="width: 100%" appearance="outline">
                <input 
                    matInput 
                    placeholder="Nome" 
                    [formControl]="nome" 
                    required
                    maxlength="255">
                <mat-error *ngIf="nome.invalid">{{getErrorNameMessage()}}</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Emissor</mat-label>
                <mat-select 
                    placeholder="Emissor"
                    [(value)]="model.orgao_emissor_id" 
                    [formControl]="orgao_emissor_id"
                    name="status_id"
                >
                    <mat-option *ngFor="let emissor of listOrgaoEmissor" [value]="emissor.id">{{emissor.nome}}</mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerEmissor"></mat-spinner>
            </mat-form-field>
        </div>
    </div>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Data de Vencimento</mat-label>
                <input 
                    matInput 
                    [matDatepicker]="picker" 
                    [formControl]="data_vencimento" 
                    name="data_vencimento" 
                    placeholder="Data de Vencimento"
                >
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Valor ROA</mat-label>
                <input 
                    matInput                     
                    [formControl]="vlr_roa" 
                    name="vlr_roa"
                    maxlength="8"
                    currencyMask
                    [options]="{  suffix: ' %', prefix: '', thousands: '.', decimal: ',' }"
                >
            </mat-form-field>
        </div>
    </div>
</div>

<div mat-dialog-actions>
    
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >
        Cancelar
    </button>   
    
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="salvar()" 
        tabindex="-1"
    >
        Salvar
    </button>

</div>